<!--
@Time : 2020/11/29 5:49 下午
@Author : yekong
@File : hebing.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="hebing">
      <div class="head1">
        <div class="l1">
          <span class="ch"></span>
          <p>可合并</p>
          <span class="la"></span>
          <p>正常</p>
        </div>
        <div class="r1">
          <div class="bt"><p>大连</p></div>
          <div class="bt"><p>北京</p></div>
          <div class="bt"><p>上海</p></div>
          <div class="bt"><p>深圳</p></div>
        </div>
      </div>
      <div class="b1">
        <div class="item"><span>公司所得税</span></div>
        <div class="item"><span>个人所得税和社保公积金</span></div>
        <div class="item"><span>土地增值税</span></div>
        <div class="item"><span>印花税</span></div>
        <div class="item"><span>房产税</span></div>
        <div class="item"><span>土地使用税</span></div>
        <div class="item"><span>增值税</span></div>
      </div>
      <div class="line1">
        <div class="itemx"><span class="ch"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="ch"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
      </div>
      <div class="line1 line2">
        <div class="itemx"><span class="ch"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="ch"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
      </div>
      <div class="line1 line3">
        <div class="itemx"><span class="ch"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="ch"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
      </div>
      <div class="line1 line4">
        <div class="itemx"><span class="ch"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="ch"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
        <div class="itemx"><span class="la"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hebing",
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.hebing {
  width: 100%;
  position: relative;

  .head1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
  }

  .l1 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #A8ACBA;

    p {
      margin-left: 10px;
      margin-right: 40px;
    }
  }

  .r1 {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;

    .bt {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: column;
      width: 75px;

      p {
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 50px;
      }

      &:after {
        width: 46px;
        height: 3px;
        display: block;
        background: #D8D8D8;
        content: ' ';
      }
    }
  }
}

.ch {
  width: 20px;
  height: 20px;
  background: #D8D8D8;
  border: 4px solid #E46F40;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
}

.la {
  width: 18px;
  height: 18px;
  background: #D8D8D8;
  border: 4px solid #42C0E3;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
}

.b1 {
  padding-top: 30px;

  .item {
    width: 100%;
    height: 34px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin-bottom: 17px;
    background: rgba(47, 55, 88, 1);

    span {
      line-height: 34px;
      background: #18234f;
      padding-right: 10px;
    }
  }
}

.line1 {
  position: absolute;
  width: 20px;
  height: 399px;
  top: 54px;
  right: 253px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: column;
  padding-top: 30px;

  span {
    z-index: 1;
    position: relative;
  }

  &:after {
    position: absolute;
    width: 1px;
    height: 380px;
    content: ' ';
    display: block;
    z-index: 0;
    top: 0;
    background: #6D7187;
  }
}

.line2 {
  right: 178px;
}

.line3 {
  right: 102px;
}

.line4 {
  right: 28px;
}

.itemx {
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  margin-bottom: 17px;
  flex-shrink: 0;
}
</style>
